import {
  FAF_TOOL_ACCESS,
  MUTUAL_DASHBOARD_ROLES,
  ROLE_TOOL_MANAGER_CLIENT,
  ROLE_TOOL_MANAGER_MISSION,
  ROLE_TOOL_MANAGER_PROSPECTION,
  ROLE_TOOL_MANAGER_SALARY,
  ROLE_TOOL_MANAGER_WORKER,
} from "access-roles/roles";
import {
  DASHBOARD_SHARED_SECTIONS,
  DELIVERY_NOTES_SECTIONS,
  MANAGER_TOOLS_REQUIRED_ROLES,
  MANAGER_TOOLS_SECTIONS,
  ROLE_MATCH_MODE,
  SECTIONS,
} from "./constants";
const { ic, fdm, ed, ok, cl, ko } = DASHBOARD_SHARED_SECTIONS || {};
const {
  prospections: prospections_tool,
  abaque: abaque_tool,
  missions: missions_tool,
  clients: clients_tool,
  consultants_subcontractors: consultants_subcontractors_tool,
  faf: faf_tool,
} = MANAGER_TOOLS_SECTIONS || {};
const {
  templates: delivery_note_templates,
  create: delivery_note_create,
  generate: delivery_note_generate,
  saved: delivery_note_saved,
} = DELIVERY_NOTES_SECTIONS || {};

export const ENTITY = {
  STAFF: "staff",
  CONSULTANT: "consultant",
  SUBCONTRACTOR: "subcontractor",
  CLIENT: "client",
  SUBCONTRACTING_COMPANY: "subcontractingCompany",
  BILLING_CLIENT: "billingClient",
  MISSION: "mission",
  MISSION_DIRECTORY: "missions",
  TOOLS: "tools",
};

export const HEADER_NAVIGATION = {
  PERSONAL: {
    icon: "personal",
    label: {
      id: "personal",
      defaultMessage: "Personnel",
    },
    section: SECTIONS.PERSONAL,
  },
  GENERAL_INFO: {
    icon: "personal",
    label: {
      id: "general_info",
      defaultMessage: "Informations générales",
    },
    section: SECTIONS.GENERAL_INFO,
  },
  DASHBOARD: {
    icon: "dashboard",
    label: {
      id: "dashboard",
      defaultMessage: "Dashboard",
    },
    section: SECTIONS.DASHBOARD,
  },
  CLIENTS: {
    icon: "clients",
    label: {
      id: "clients",
      defaultMessage: "Clients",
    },
    section: SECTIONS.CLIENTS,
  },
  MISSIONS: {
    icon: "folder",
    label: {
      id: "missions",
      defaultMessage: "Missions",
    },
    section: SECTIONS.MISSIONS,
    requiredRoles: ROLE_TOOL_MANAGER_MISSION,
  },
  SUBCONTRACTORS: {
    icon: "folder",
    label: {
      id: "subcontractors",
      defaultMessage: "Sous-traitants",
    },
    section: SECTIONS.SUBCONTRACTORS,
  },
  BILLING: {
    icon: "folder",
    label: {
      id: "billing",
      defaultMessage: "Facturation",
    },
    section: SECTIONS.BILLING,
  },
  ic: {
    label: {
      id: "dashboard_shared_navigation_intercontracts",
      defaultMessage: "Intercontrats",
    },
    section: ic,
    requiredRoles: MUTUAL_DASHBOARD_ROLES.ROLE_GET_MUTUAL_IC,
  },
  fdm: {
    label: {
      id: "dashboard_shared_navigation_missions_exit_to_active",
      defaultMessage: "Sortie des missions à actionner",
    },
    section: fdm,
    requiredRoles: MUTUAL_DASHBOARD_ROLES.ROLE_GET_MUTUAL_FDM,
  },
  ed: {
    label: {
      id: "dashboard_shared_navigation_eds",
      defaultMessage: "Embauches directes",
    },
    section: ed,
    requiredRoles: MUTUAL_DASHBOARD_ROLES.ROLE_GET_MUTUAL_ED,
  },
  ok: {
    label: {
      id: "dashboard_shared_navigation_ok",
      defaultMessage: "OK",
    },
    section: ok,
    requiredRoles: MUTUAL_DASHBOARD_ROLES.ROLE_GET_MUTUAL_OK,
  },
  cl: {
    label: {
      id: "dashboard_shared_navigation_long_leave",
      defaultMessage: "Congés longs",
    },
    section: cl,
    requiredRoles: MUTUAL_DASHBOARD_ROLES.ROLE_GET_MUTUAL_CL,
  },
  ko: {
    label: {
      id: "dashboard_shared_navigation_companies_exits",
      defaultMessage: "Sorties sociétés",
    },
    section: ko,
    requiredRoles: MUTUAL_DASHBOARD_ROLES.ROLE_GET_MUTUAL_KO,
  },
  MISSIONS_TOOL: {
    icon: "folder",
    label: {
      id: "missions",
      defaultMessage: "Missions",
    },
    section: missions_tool,
    requiredRoles: ROLE_TOOL_MANAGER_MISSION,
  },
  CLIENTS_TOOL: {
    icon: "user",
    label: {
      id: "clients",
      defaultMessage: "Outils",
    },
    section: clients_tool,
    requiredRoles: ROLE_TOOL_MANAGER_CLIENT,
  },
  CSLT_STR_TOOL: {
    icon: "user",
    label: {
      id: "cslt_str",
      defaultMessage: "Consultants / Sous-traitants",
    },
    section: consultants_subcontractors_tool,
    requiredRoles: ROLE_TOOL_MANAGER_WORKER,
  },
  PROSPECTIONS_TOOL: {
    icon: "prospections",
    label: {
      id: "surveys",
      defaultMessage: "Prospections",
    },
    section: prospections_tool,
    requiredRoles: ROLE_TOOL_MANAGER_PROSPECTION,
  },
  ABAQUE_TOOL: {
    icon: "salary",
    label: {
      id: "abaque",
      defaultMessage: "Outil abaque salaire",
    },
    section: abaque_tool,
    requiredRoles: ROLE_TOOL_MANAGER_SALARY,
  },
  // Delivery notes reuse the "Outils manager" visibility as a whole (no new
  // right), hence the OR: holding any one of those roles opens every tab.
  DELIVERY_NOTE_TEMPLATES: {
    icon: "folder",
    label: {
      id: "delivery_note_templates_tab",
      defaultMessage: "Mes modèles",
    },
    section: delivery_note_templates,
    requiredRoles: MANAGER_TOOLS_REQUIRED_ROLES,
    rolesMatchMode: ROLE_MATCH_MODE.OR,
  },
  DELIVERY_NOTE_CREATE: {
    icon: "add",
    label: {
      id: "delivery_note_create_tab",
      defaultMessage: "Créer un modèle",
    },
    section: delivery_note_create,
    requiredRoles: MANAGER_TOOLS_REQUIRED_ROLES,
    rolesMatchMode: ROLE_MATCH_MODE.OR,
  },
  DELIVERY_NOTE_GENERATE: {
    icon: "notes",
    label: {
      id: "delivery_note_generate_tab",
      defaultMessage: "Générer un bon de livraison",
    },
    section: delivery_note_generate,
    requiredRoles: MANAGER_TOOLS_REQUIRED_ROLES,
    rolesMatchMode: ROLE_MATCH_MODE.OR,
  },
  DELIVERY_NOTE_SAVED: {
    icon: "archive",
    label: {
      id: "delivery_note_saved_tab",
      defaultMessage: "Bons enregistrés",
    },
    section: delivery_note_saved,
    requiredRoles: MANAGER_TOOLS_REQUIRED_ROLES,
    rolesMatchMode: ROLE_MATCH_MODE.OR,
  },
  FAF_TOOL: {
    icon: "folder",
    label: {
      id: "tools_manager_faf_tab",
      defaultMessage: "Fast & Furious",
    },
    section: faf_tool,
    ...FAF_TOOL_ACCESS,
  },
};

export const INFO_HEADER_NAVIGATION = {
  deliveryNotes: [
    HEADER_NAVIGATION.DELIVERY_NOTE_SAVED,
    HEADER_NAVIGATION.DELIVERY_NOTE_GENERATE,
    HEADER_NAVIGATION.DELIVERY_NOTE_CREATE,
    HEADER_NAVIGATION.DELIVERY_NOTE_TEMPLATES,
  ],
  staff: [
    HEADER_NAVIGATION.PERSONAL,
    HEADER_NAVIGATION.DASHBOARD,
    HEADER_NAVIGATION.CLIENTS,
    HEADER_NAVIGATION.MISSIONS,
  ],
  consultant: [
    HEADER_NAVIGATION.PERSONAL,
    HEADER_NAVIGATION.DASHBOARD,
    HEADER_NAVIGATION.MISSIONS,
  ],
  subcontractor: [HEADER_NAVIGATION.PERSONAL, HEADER_NAVIGATION.MISSIONS],
  client: [HEADER_NAVIGATION.GENERAL_INFO, HEADER_NAVIGATION.MISSIONS],
  subcontractingCompany: [
    HEADER_NAVIGATION.PERSONAL,
    HEADER_NAVIGATION.SUBCONTRACTORS,
  ],
  billingClient: [HEADER_NAVIGATION.GENERAL_INFO, HEADER_NAVIGATION.CLIENTS],
  mission: [HEADER_NAVIGATION.GENERAL_INFO, HEADER_NAVIGATION.BILLING],
  tools: [
    HEADER_NAVIGATION.FAF_TOOL,
    HEADER_NAVIGATION.MISSIONS_TOOL,
    HEADER_NAVIGATION.CLIENTS_TOOL,
    HEADER_NAVIGATION.CSLT_STR_TOOL,
    HEADER_NAVIGATION.PROSPECTIONS_TOOL,
    HEADER_NAVIGATION.ABAQUE_TOOL,
  ],
  sharedDashboard: [
    HEADER_NAVIGATION.ic,
    HEADER_NAVIGATION.fdm,
    HEADER_NAVIGATION.ed,
    HEADER_NAVIGATION.ok,
    HEADER_NAVIGATION.cl,
    HEADER_NAVIGATION.ko,
  ],
};
